import { i as e } from "./identity.js";
import { _ as o } from "./_overRest.js";
import { _ as s } from "./_setToString.js";
var i = e, a = o, _ = s;
function m(t, r) {
  return _(a(t, r, i), t + "");
}
var R = m;
export {
  R as _
};
//# sourceMappingURL=_baseRest.js.map
